const extractDomain = (href?: string) => {
    try {
        const url = new URL(href || '');
        return url.hostname;
    } catch {
        return window && window?.location?.hostname;
    }
}

export default extractDomain;const extractDomain = (href?: string) => {
    try {
        const url = new URL(href || '');
        return url.hostname;
    } catch {
        return window && window?.location?.hostname;
    }
}

export default extractDomain;